import { render, staticRenderFns } from "./UpsertCompanyModal.vue?vue&type=template&id=35049caa&"
import script from "./UpsertCompanyModal.vue?vue&type=script&lang=ts&"
export * from "./UpsertCompanyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports